import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {getStoredState} from '../launch/store'
import {AppContext} from '../app/app'
import Page from '../page/page'

import './starbase.css'

const Starbase = () => {
    const state = getStoredState()
    const {setGameLoadingPercent, togglePaused} = useContext(AppContext)

    return (
        <Page className="home">
            <Link className="button-1" to="configure">
                New Mission
            </Link>

            {state && state.entities && Object.keys(state.entities).length ? (
                <Link
                    className="button-1"
                    to="launch"
                    onClick={() => {
                        setGameLoadingPercent(0)
                        togglePaused(false)
                    }}
                >
                    Resume Mission
                </Link>
            ) : null}

            {state && state.careerStats && state.careerStats.score ? (
                <Link className="button-1" to="achievements">
                    Achievements
                </Link>
            ) : null}
        </Page>
    )
}

export default Starbase
